import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetFortAgentStaticPayoutRecords } from "@/api";
import type { GetFortAgentStaticPayoutRecordsResponse } from "@/api/types";
import { useUserStore } from "@/store/useUserStore";

export const FORT_AGENT_PAYOUT_PAGE_SIZE = 100;

export function useGetFortAgentStaticPayoutRecords(
  agentId: number,
  enabled: boolean
) {
  const { userInfo } = useUserStore();
  return useInfiniteQuery({
    queryKey: ["fortAgentStaticPayoutRecords", agentId],
    queryFn: async ({
      pageParam,
    }): Promise<GetFortAgentStaticPayoutRecordsResponse> => {
      const res = await ApiGetFortAgentStaticPayoutRecords({
        page: pageParam,
        pageSize: FORT_AGENT_PAYOUT_PAGE_SIZE,
        agentId,
      });
      console.log("useGetFortAgentStaticPayoutRecords", res.data);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: enabled && !!userInfo?.address,
  });
}
